export class TimeManager {
  constructor(initialHour = 12, initialMinute = 0) {
    this.gameTime = new Date();
    this.gameTime.setHours(initialHour, initialMinute, 0, 0);
  }

  setTime(hours, minutes) {
    this.gameTime.setHours(hours, minutes, 0, 0);
  }

  getTime() {
    return this.gameTime;
  }

  getHours() {
    return this.gameTime.getHours();
  }

  getMinutes() {
    return this.gameTime.getMinutes();
  }

  getTimeString() {
    const hours = this.gameTime.getHours();
    const minutes = this.gameTime.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  }
}
